import LoadingSkeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

type Props = Omit<React.ComponentProps<typeof LoadingSkeleton>, 'baseColor' | 'highlightColor'>

export function Skeleton(props: Props) {
    return <LoadingSkeleton baseColor="#f0f0f0" highlightColor="#fbfbfb" {...props} />
}
